import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

import { VueReCaptcha } from 'vue-recaptcha-v3'

Vue.config.productionTip = false
Vue.use(VueReCaptcha, { siteKey: '6LdHRM4ZAAAAABjXOO9Z4f_zXXnEJPf-emfZzF01' })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
